import { AlulaResponseData } from "@app/shared/databases/alula.database";
import { ImportMap } from "@app/shared/resources/class-importer-exporter.service";

export interface AlulaDealerInt {
    id: string;
    stationId: string;
    accountNumber: string;
    companyName: string;
    email: string;
    username: string;
    accountName: string;
    firstName: string;
    lastName: string;
    relayGroupAllEnabled: boolean;
}

interface AlulaDealerData {
    id: string;
    stationId: string;
    acntNo: string;
    companyName: string;
    email: string;
    username: string;
    accountName: string;
    nameFirst: string;
    nameLast: string;
    relayGroupAllEnabled: boolean;
}

export class AlulaDealer {
    static readonly importMap: ImportMap<AlulaDealerInt, AlulaDealerData> = [
        { i: "id", o: "id" },
        { i: "stationId", o: "stationId" },
        { i: "acntNo", o: "accountNumber" },
        { i: "companyName", o: "companyName" },
        { i: "email", o: "email" },
        { i: "username", o: "username" },
        { i: "accountName", o: "accountName" },
        { i: "nameFirst", o: "firstName" },
        { i: "nameLast", o: "lastName" },
        { i: "relayGroupAllEnabled", o: "relayGroupAllEnabled" },
    ];

    static fromDbObject(dealerData: AlulaResponseData): AlulaDealer {
        if (dealerData) {
            return new AlulaDealer(
                dealerData.id,
                dealerData.attributes[AlulaDealer.importMap[1].i],
                dealerData.attributes[AlulaDealer.importMap[2].i],
                dealerData.attributes[AlulaDealer.importMap[3].i],
                dealerData.attributes[AlulaDealer.importMap[4].i],
                dealerData.attributes[AlulaDealer.importMap[5].i],
                dealerData.attributes[AlulaDealer.importMap[6].i],
                dealerData.attributes[AlulaDealer.importMap[7].i],
                dealerData.attributes[AlulaDealer.importMap[8].i],
                dealerData.attributes[AlulaDealer.importMap[9].i]
            );
        }
        return null;
    }
    constructor(
        public id?: string,
        public stationId?: string,
        public accountNumber?: string,
        public companyName?: string,
        public email?: string,
        public username?: string,
        public accountName?: string,
        public firstName?: string,
        public lastName?: string, // public stationBilling: boolean // public password: string, // public uType: number,
        public relayGroupAllEnabled?: boolean
    ) {}
}
